import { selector } from 'recoil';
import { OnlineSales } from 'gw-edge-client';
import { resumeOnsaAtom } from '../atoms/resumeOnsaAtom';
import { onsaInfoAtom } from '../atoms/onsaInfoAtom';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { topConfigContextAtom } from '../atoms/topConfigContextAtom';
import { getPrimaryAccountNumber } from '../../utils/topConfigContextUtil';
import type { ResumeOnsaInfo } from '../types/onsaTypes';

export const resumeOnsaSelector = selector<ResumeOnsaInfo>({
    key: 'resumeOnsaSelector',
    get: async ({ get }) => {
        const onsaResume = get(onsaInfoAtom);
        let jobInfoDTO = {
            isExistingBasket: false,
            jobNumber: '',
            sessionId: '',
            isPolicyChange: false
        };

        if (
            onsaResume.onsaStep === 'CoveragePackagePage' ||
            onsaResume.onsaStep === 'ShoppingBasketPage'
        ) {
            const topConfigContext = get(topConfigContextAtom);
            jobInfoDTO = get(jobInfoAtom);

            const resumeOnsa = get(resumeOnsaAtom);
            const accountNumber = getPrimaryAccountNumber(topConfigContext);

            const moveSubmissionPromise = OnlineSales.moveSubmissionToCustomerAccount(
                jobInfoDTO.jobNumber,
                resumeOnsa.jobNumber,
                jobInfoDTO.sessionId,
                resumeOnsa.sessionId
            );

            const customerStopDTO = await OnlineSales.getVIDCustomerStop(
                jobInfoDTO.jobNumber,
                accountNumber,
                jobInfoDTO.sessionId
            );

            if (customerStopDTO.stopCause !== 'None') {
                return {
                    ...jobInfoDTO,
                    stopCause: customerStopDTO.stopCause,
                    conflictingCoverables: []
                };
            }

            const conflictingCoverables = await moveSubmissionPromise;

            return {
                ...jobInfoDTO,
                stopCause: 'None',
                conflictingCoverables
            };
        }

        return {
            ...jobInfoDTO,
            stopCause: 'None',
            conflictingCoverables: []
        };
    }
});
